import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        loading: false,
        error: null,
        dynamicComponent: null,
        displayProgressBar: true,
    },
    getters: {
        loading: state => state.loading,
        error: state => state.error,
        getTransparentColor: () => (color) => `${color}7f`,
    },
    mutations: {
        SET_LOADING(state, flag) {
            state.loading = flag;
        },
        API_DATA_FAILURE(state, error) {
            state.error = error;
        },
        setDynamicComponent(state, value) {
            state.dynamicComponent = value;
        },
        setDisplayProgressBar: (state, displayProgressBar) => state.displayProgressBar = displayProgressBar,
    },
    actions: {}
});

Vue.$store = store;

export default store;
